<template lang="pug">
  range-slider.slider(v-model.number="sliderValue", min=0, :max="nStep", step=1)
</template>

<script lang="ts">
import { Prop, Component, Vue } from "vue-property-decorator";

@Component
export default class LogScaleRangeComponent extends Vue {
  @Prop({ required: true })
  min!: number

  @Prop({ required: true })
  max!: number

  @Prop({ default: 1 })
  a!: number

  @Prop({ default: 10000 })
  nStep!: number

  @Prop({ required: true })
  value!: number

  private f(x: number) {
    return Math.sinh(this.a * x) / Math.sinh(this.a)
  }

  private g(y: number) {
    return Math.asinh(y * Math.sinh(this.a)) / this.a
  }

  private get xMin() {
    return this.g(this.min)
  }

  private get xMax() {
    return this.g(this.max)
  }

  get sliderValue() {
    const x = this.g(this.value)
    const r = (x - this.xMin) / (this.xMax - this.xMin)
    const v = r * this.nStep
    return v
  }

  set sliderValue(v: number) {
    const r = v / this.nStep
    const x = this.xMin + r * (this.xMax - this.xMin)
    this.$emit('input', this.f(x))
  }
}
</script>

<style lang="scss" scoped>
.slider {
  width: 100%;
}
</style>